import { AxiosError } from 'axios'
import { Session } from '../dto/session'
import httpClient from './api'

import { GetResult, Preferences as preferences } from '@capacitor/preferences';
import { Organization } from '../dto/organization';

export const initSession = async (): Promise<Session | undefined> => {
    try {
        const response: any = await httpClient.get('/api/session')
        const session: Session = response.data;
        await preferences.set({ key: 'session', value: JSON.stringify(session) })
        return response.data as Session
    } catch (error: any) {
        if (AxiosError.ERR_NETWORK !== error.code) {
            await logout()
        } else {
            console.error('Erro ao buscar session!', error)
            return getSession()
        }
    }
}

export const login = async (email: string, password: string) => {
    const response = await httpClient.post('/api/auth/login', { email: email, password: password })
    await preferences.set({ key: 'token', value: response.data.token })
    await preferences.set({ key: 'tokenUpdate', value: response.data.tokenUpdate })

    const session: Session = response.data.session;
    await preferences.set({ key: 'session', value: JSON.stringify(session) })
    await preferences.set({ key: 'currentOrganization', value: JSON.stringify(session.organizations[0]) })
}

export const updateToken = async (token: string | null) => {
    if (token) {
        await preferences.set({ key: 'token', value: token })
    } else {
        await preferences.remove({ key: 'token' });
    }
}

export const logout = async () => {
    await preferences.remove({ key: 'session' })
    await preferences.remove({ key: 'token' })
    await preferences.remove({ key: 'tokenUpdate' })
    await preferences.remove({ key: 'currentOrganization' })

    const keys = ['session', 'token', 'tokenUpdate', 'currentOrganization', 'user_email', 'user_password'];
    
    for (const key of keys) {
      const { value } = await preferences.get({ key });
      console.log(`Key: ${key}, Value: ${value}`);
    }

}

export const getSession = async (): Promise<Session> => {
    const { value } = await preferences.get({ key: 'session' });
    return JSON.parse(value as string) as Session;
}

export const getCurrentOrganization = async (): Promise<Organization> => {
    const result:GetResult = await preferences.get({ key: 'currentOrganization' })
    try {
        return JSON.parse(result.value as string) as Organization;
    } catch (error) {
        // console.error('Erro ao buscar Organization Default', error)
    }
       
    return {} as Organization
}

export const setCurrentOrganization = async (organization: Organization): Promise<void> => {
    await preferences.set({ key: 'currentOrganization', value: JSON.stringify(organization) })
}

export const getToken = async (): Promise<string> => {
    const { value } = await preferences.get({ key: 'token' });
    return value as string
}

export const getTokenUpdate = async (): Promise<string> => {
    const { value } = await preferences.get({ key: 'tokenUpdate' });
    return value as string
}

const encodeBase64 = (str: string) => btoa(unescape(encodeURIComponent(str)));

export const saveLogin = async (email: string, password: string) => {
    console.log('--------------------------------------------', email)
  await preferences.set({ key: 'user_email', value: email });
  await preferences.set({ key: 'user_password', value: encodeBase64(password) });
};

const decodeBase64 = (str: string) => decodeURIComponent(escape(atob(str)));

export const getLogin = async () => {
    const { value } = await preferences.get({key: 'user_email' });
    const email = value
  console.log("emaillllll", email)
  const encodedPassword = (await preferences.get({ key: 'user_password' })).value;
  const password = encodedPassword ? decodeBase64(encodedPassword) : null;
  return { email, password };
};

export const clearLogin = async () => {
    await preferences.remove({ key: 'user_email' });
    await preferences.remove({ key: 'user_password' });
};